import { render, staticRenderFns } from "./TipoTerceros.vue?vue&type=template&id=02fa2c38"
import script from "./TipoTerceros.vue?vue&type=script&lang=js"
export * from "./TipoTerceros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports